import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  makeForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  makeId: undefined,
  showMakePopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const makeSlice = createSlice({
  name: "makes",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    makeListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    makeList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadMakeForEdit: (state, action) => {
      const payload = action.payload;

      state.makeForEdit.make = payload.name;
      state.makeForEdit.id = payload.id;
      state.makeForEdit.categoryId = payload.category;
      state.makeForEdit.assetClassId = payload.category?.assetCategoryClass;
    },
    loadMakeMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    openMakeApprove: (state, action) => {
      const { makeId } = action.payload;

      state.makeId = makeId;
      state.showMakePopover = !state.showMakePopover;
    },
    setDeleteDialogData: (state, action) => {
      const { makeId } = action.payload;

      state.showDeleteDialog = !state.showDeleteDialog;
      state.makeId = makeId;
    },
  },
});
